<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: jinchuan.lee
 * @Date: 2021-05-06 09:41:50
 * @LastEditors: jinchuan.lee
 * @LastEditTime: 2021-06-09 10:48:22
-->
<template>
	<el-button
		:size="size"
		:style="{width:width}"
    :disabled="disabled"
	:loading="loading"
		@click="$emit('click','')"
    class="publicBtn"
		:class = "{
			'btn--confirm': type==='1',
			'btn--cancal': type==='2',
			'btn--dashed': type==='3',
			'btn--operation': type==='4',
		}"
	>
    <img :src="icon" alt="" v-if="icon" class='iconImg'>
		{{text}}
	</el-button>
</template>
<script>
	export default {
	    props:{
		loading:{
			type:Boolean,
			default:false,
		},
        icon:{
	    		type:String,
	    		default:""
	    	},
	    	text:{
	    		type:String,
	    		default:"确定"
	    	},
	    	size:{
	    		type:String,
	    		default:"small"
	    	},
	    	width:{
	    		type:String,
	    		default:"122px"
	    	},
        disabled:{
          type:Boolean,
          default:false
        },
		// type  1 确认按钮  2 取消按钮 3 取消按钮--虚线 4 常规操作  蓝色
		type:{
			type:String,
			default:"1"
		}
	    }
	}
</script>
<style lang="less" scoped>
	@import "../../assets/css/accBtn.less";
</style>



// WEBPACK FOOTER //
// src/components/accBtn/index.vue